import { DataGridPro } from "@mui/x-data-grid-pro";
import { LinearProgress } from "@mui/material";
import { useCallback, useContext, useMemo } from "react";
import { FilterTotal } from "../../filter/FilterTotal";
import { Context } from "../timecard/Context";
import { useTranslation } from "react-i18next";

const Table = ({ open }) => {
  const { t } = useTranslation("totals.table");

  const { totals, loadingGettingTotals, setLoadingGettingTotals } =
    useContext(Context);

  const columns = useMemo(
    () => [
      {
        field: "paycode",
        headerName: t("totals.table.columns.paycode"),
        flex: 1.5,
      },
      /* {
            field: 'cost_center', 
            headerName: 'Centro de costo',
            flex: 3,
        }, */
      {
        field: "amount",
        headerName: t("totals.table.columns.amount"),
        align: "center",
        headerAlign: "center",
        minWidth: 150,
        width: 150,
      },
    ],
    [t],
  );

  /* useEffect(() => {
    if (open) {
      gettingTotal(range3, employee);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]); */

  return (
    <>
      <DataGridPro
        showCellVerticalBorder
        showColumnVerticalBorder
        loading={loadingGettingTotals}
        columns={columns}
        rows={totals}
        slots={{
          toolbar: useCallback(
            () => <FilterTotal setLoading={setLoadingGettingTotals} />,
            [setLoadingGettingTotals],
          ),
          loadingOverlay: LinearProgress,
        }}
        sx={{
          height: "38vh",
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
        disableRowSelectionOnClick
        hideFooter
      />
    </>
  );
};

export { Table };
